import Splide from '@splidejs/splide';
import {AutoScroll} from '@splidejs/splide-extension-auto-scroll';
( function( app ) {
  const COMPONENT = {
    init: function() {
      if ( $( '.marquee__splide' ).length ) {
        $( '.marquee__splide' ).each( function( index, element ) {
          const marqueText = $( element ).find( '.marquee__slide-text .marquee-text' );
          let marqueTextWidth = 0;
          marqueText.each( function( index, el ) {
            marqueTextWidth = marqueTextWidth + $( el ).outerWidth();
          } );
          const slider = new Splide( $( element )[0], {
            type: 'loop',
            drag: 'free',
            gap: '2rem',
            arrows: false,
            fixedWidth: `${marqueTextWidth}px`,
            pagination: false,
            autoScroll: {
              speed: .5,
              pauseOnFocus: false,
              pauseOnHover: false,
            },
          } );
          slider.mount( {AutoScroll} );
        } );
      }
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'marquee', COMPONENT );
} )( app );
